export default function (Site, $) {
  Site.widget('load-more', {
    _create () {
      var more = $(this.element)
      more.click((e) => {
        var data = more.data('query')
        var page = more.attr('data-page')
        var max  = more.data('max')
        this.loadMore(e, data, page, max, more)
      })
    },
    loadMore (e, data, page, max, more) {
      e.preventDefault()
      $.ajax({
        type: 'get',
        url: ajax_custom,
        data: {
          action: 'ajax_loadmore',
          post_type: data.post_type,
          posts_per_page: data.posts_per_page,
          paged: page,
          offset: data.offset
        },
        success: function (resp) {
          $('.annual-reports').append(resp)
          more.attr('data-page', parseInt(page) + 1)

          if ( max === parseInt(page) + 2) {
            more.fadeOut(200, function() {
              this.remove()
            })
          }
        }
      })
    }
  })
}
